import {DateTime} from 'luxon';
import {Alumno, Aula, Aviso, Fichaje, Padre, SemanasProyecto, Vacaciones, Worker} from '@kilobytelab/types';

export const apellidosHelper = (padre: Padre): Padre => {
  if (padre) {
    if (!padre.ap1 && padre.apellidos) {
      padre.ap1 = padre.apellidos.split(' ')[0];
      padre.ap2 = padre.apellidos.split(' ')[1] || ''
    }
    padre.nombreCompleto = `${padre.nombre} ${padre.ap1} ${padre.ap2}`;
  }
  return padre
}

export const showVacas = (fecha: string): boolean => {
  if (!fecha) return false;
  const [d, m] = fecha.split('/');
  const now: DateTime = DateTime.now().startOf('day');
  if (now.month >= 9) return false;
  const date: DateTime = now.set({ day: +d, month: +m }).startOf('day');
  return now >= date
}

export const getCursoActual = (): string => {
  const hoy = new Date();
  const actual: number = hoy.getMonth() < 8 ? hoy.getFullYear() - 1 : hoy.getFullYear();
  return `${actual}-${actual + 1}`
}

export const getCursoSiguiente = (): string => {
  const hoy = new Date();
  const actual: number = hoy.getMonth() < 8 ? hoy.getFullYear() : hoy.getFullYear() + 1;
  return `${actual}-${actual + 1}`
}

export const getCurso = (fecha: DateTime): string => {
  const actual: number = fecha.month < 9 ? fecha.year - 1 : fecha.year;
  return `${actual}-${actual + 1}`
}

export const setNumberDay = (year: number, month: number, semana: number, dia: number): string => {
  const firstDay: number = DateTime.local().set({year: year, month: month, day: 1}).weekday;
  const lastDay: number = DateTime.local().set({year: year, month: month}).daysInMonth;
  if (semana === 1) {
    return firstDay > dia ? '' : String(dia - firstDay + 1);
  }
  const value: number = 7 * (semana - 1) + dia - firstDay + 1;
  return value > lastDay ? '' : String(value);
}

export const getCursoFromYear = (year: number): string => `${year}-${year + 1}`;

export const buildSemanasProyectos = (curso?: string): SemanasProyecto[] => {
  const year: number = curso ? +curso.split('-')[0] : +getCursoActual().split('-')[0];
  const primerosept: number = new Date(year, 8, 1).getDay();
  const semanas: {semana: number, limites: string}[] = [];
  const limit: DateTime = DateTime.local(year + 1, 8, 31);
  let siguiente: DateTime;
  let i: number = 2;
  if (primerosept > 0 && primerosept < 6) {
    const final = `${8 - primerosept}/09/${year}`;
    const inicio: DateTime = DateTime.local(year, 9, 1).minus({days: primerosept - 1});
    semanas.push({
      semana: 1,
      limites: `${inicio.toLocaleString(DateTime.DATE_SHORT)}-${final}`
    });
    siguiente = DateTime.local(year, 9, 9 - primerosept)
  } else {
    if (primerosept === 0) {
      semanas.push({
        semana: 1,
        limites: `2/09/${year}-8/09/${year}`
      });
      siguiente = DateTime.local(year, 9, 9)
    } else {
      semanas.push({
        semana: 1,
        limites: `3/09/${year}-9/09/${year}`
      });
      siguiente = DateTime.local(year, 9, 10)
    }
  }
  while (siguiente < limit) {
    semanas.push({
      semana: i,
      limites: siguiente.toLocaleString(DateTime.DATE_SHORT) + '-' +
        siguiente.plus({days: 6}).toLocaleString(DateTime.DATE_SHORT)
    });
    siguiente = siguiente.plus({days: 7});
    i++
  }
  return semanas
}

export const getWeeknumberFromDate = (date: string): number => {
  const fecha: DateTime = DateTime.fromSQL(date);
  const year: number = fecha.month >= 9 ? fecha.year : fecha.year - 1;
  const primerosept: number = new Date(year, 8, 1).getDay();
  let inicioSemana1: DateTime;
  if (primerosept > 0 && primerosept < 6) {
    inicioSemana1 = DateTime.local(year, 9, 1).minus({ days: primerosept - 1 });
  } else if (primerosept === 0) {
    inicioSemana1 = DateTime.local(year, 9, 2);
  } else {
    inicioSemana1 = DateTime.local(year, 9, 3);
  }
  const inicio: DateTime = inicioSemana1.startOf('day');
  const objetivo: DateTime = fecha.startOf('day');
  const diffDias: number = objetivo.diff(inicio, 'days').days;
  if (diffDias < 0) return 0;
  return Math.floor(diffDias / 7) + 1;
}

const isNatural = (n: any): boolean => n % 1 === 0 && n >= 0;

export const setHora = (hora: string): number => {
  if (!hora) return 0;
  const [hStr, mStr] = hora.split(':');
  const horas = +hStr || 0;
  const minutos = +mStr || 0;
  const esValido = isNatural(horas) && isNatural(minutos) && horas < 24 && minutos < 60;
  return esValido ? (horas * 3600) + (minutos * 60) : 0
}

export const getHoraCompleta = (time: number | string): string => {
  const totalSeconds = +time;
  if (!totalSeconds || totalSeconds <= 0) return '';
  const horas = Math.floor(totalSeconds / 3600);
  const minutos = Math.floor((totalSeconds % 3600) / 60);
  return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`
}

export const sortChildByEntryTime = (a: Vacaciones, b: Vacaciones): number => setHora(a.hentrada) - setHora(b.hentrada);

export const sortAulaByNumber = (a: Aula, b: Aula): number => a.numeroAula - b.numeroAula;

export const sortAulaByName = (a: Aula, b: Aula) => a.nombreAula.localeCompare(b.nombreAula);

export const sortByMomento = (a: Aviso, b: Aviso): number => DateTime.fromSQL(b.momento).toSeconds() - DateTime.fromSQL(a.momento).toSeconds();

export const sortByName = (a: Worker | Alumno, b: Worker | Alumno) => a.nombreCompleto.localeCompare(b.nombreCompleto);

export const sortFichajes = (a: Fichaje, b: Fichaje) => {
  const ela: number = DateTime.fromFormat(a.moment, 'HH:mm:ss').toMillis();
  const elb: number = DateTime.fromFormat(b.moment, 'HH:mm:ss').toMillis();
  return ela - elb
}